import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './components/home/home.component';
import { PrincipalComponent } from './components/principal/principal.component';
import {AuthGuard} from '../app/guards/auth.guard';
import {NologinGuard} from '../app/guards/nologin.guard';

const routes: Routes = [

  {path:'principal',component:PrincipalComponent,canActivate:[NologinGuard]},
  {path:'home',component:HomeComponent,canActivate:[AuthGuard] },
  { path : "**" , pathMatch : "full" , redirectTo : "home" , canActivate: [AuthGuard]}

 
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
